import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppointmentService } from 'src/app/services/appointment.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-dual-days-alcon',
	templateUrl: './dual-days-alcon.component.html',
	styleUrls: ['./dual-days-alcon.component.css']
})
export class DualDaysAlconComponent implements OnInit {
	public appointmentForm: FormGroup;

	constructor(private formBuilder: FormBuilder, private appointmentService: AppointmentService) {
		this.appointmentForm = this.formBuilder.group({
			name: [null, [Validators.required]],
			email: [null, [Validators.required, Validators.email]],
			phone: [null, [Validators.required]]
		});
	}

	ngOnInit(): void {
	}

	send() {
		this.appointmentService.landing(this.appointmentForm.value).subscribe((data: any) => {
			this.appointmentForm.reset({
				name: '',
				email: '',
				phone: ''
			});

			if (data.status == 'OK') {
				Swal.fire({
					title: 'Enviada!',
					text: 'Marcação de Avaliação enviada com sucesso',
					icon: 'success',
					confirmButtonText: 'Fechar',
					confirmButtonColor: '#329910'
				});
			}
		});
	}
}
